import Vue from 'vue';
import axios from 'axios';
import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

export default (form) => {
    if (form.querySelector('.vue-product-dropdowns')) {
        Array.from(form.querySelectorAll('.vue-product-dropdowns')).forEach((element) => {
            new Vue({
                el: element,
                delimiters: ['${', '}'],
                components: {
                    vSelect,
                },
                data: {
                    itemsPrimary: ['Inverter', 'PV Module'],
                    itemsPrimaryApi: null,
                    itemsPrimarySelectedValue: null,
                    itemsSecondary: [],
                    itemsSecondaryApi: null,
                    itemsSecondarySelectedValue: null,
                    itemsSecondarySelectedTitle: null,
                    itemsSecondaryValueKey: null,
                    itemsThird: [],
                    itemsThirdApi: null,
                    itemsThirdSelectedValue: null,
                    itemsThirdSelectedId: null,
                    itemsThirdValueKey: null,
                    isLoading: false,
                },
                computed: {
                    itemsSecondaryApiFiltered() {
                        return `${this.itemsSecondaryApi}/${this.itemsPrimarySelectedValue}.json`;
                    },
                    itemsThirdApiFiltered() {
                        return `${this.itemsThirdApi}/${this.itemsSecondarySelectedValue}/models/${this.itemsPrimarySelectedValue}.json`;
                    },
                },
                watch: {
                    itemsPrimarySelectedValue() {
                        this.fetch(this.itemsSecondaryApiFiltered)
                            .then((items) => {
                                this.itemsSecondary = items;
                            });
                            // console.log(this.itemsPrimarySelectedValue); // eslint-disable-line
                    },
                    itemsSecondarySelectedValue() {
                        this.fetch(this.itemsThirdApiFiltered)
                            .then((items) => {
                                this.itemsThird = items;
                            });
                    },
                },
                beforeMount() {
                    this.itemsSecondaryApi = this.$el.attributes['data-secondary-api'].value;
                    this.itemsSecondaryValueKey = this.$el.attributes['data-secondary-value-key'].value;
                    this.itemsSecondaryTitleKey = this.$el.attributes['data-secondary-title-key'].value;
                    this.itemsThirdApi = this.$el.attributes['data-third-api'].value;
                    this.itemsThirdValueKey = this.$el.attributes['data-third-value-key'].value;
                    this.itemsThirdIdKey = this.$el.attributes['data-third-id-key'].value;
                },
                methods: {
                    fetch(api) {
                        this.isLoading = true;
                        return axios.get(api)
                            .then((results) => {
                                this.isLoading = false;
                                return results.data.data;
                            });
                    },
                    setItemsPrimarySelectedValue(value) {
                        switch(value) {
                            case 'Inverter':
                                value = 'inverter';
                                 break;
                            case 'PV Module':
                                value = 'pvModule';
                                break;
                        }

                        this.itemsPrimarySelectedValue = value;
                    },
                    setItemsSecondarySelectedValue(value) {
                        this.itemsSecondarySelectedValue = (value ? value[this.itemsSecondaryValueKey] : null);
                        this.itemsSecondarySelectedTitle = (value ? value[this.itemsSecondaryTitleKey] : null);
                    },
                    setItemsThirdSelectedValue(value) {
                        this.itemsThirdSelectedValue = (value ? value[this.itemsThirdValueKey] : null);
                        this.itemsThirdSelectedId = (value ? value[this.itemsThirdIdKey] : null);
                    },
                },
            });
        });
    }
};
